import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CortesService } from "../../servicios/cortes.service";
import { CatUsuariosService } from "../../servicios/cat-usuarios.service";
import { CatSucursalService } from "../../servicios/cat-sucursal.service";
import { ActivatedRoute } from "@angular/router";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { Cortes } from '../../entidades/entidades';
import { CatUsuarios } from "../../entidades/entidades";
import { CatSucursales, RegistroBitacoraInput  } from "../../entidades/entidades";
import { AuthenticationService } from "app/servicios";
import { RegistroBitacoraService } from '../../servicios/registro-bitacora.service';
import { DotacionInicialService } from "../../servicios/dotacion-inicial.service";



@Component({
  selector: "app-cortes",
  templateUrl: "./cortes.component.html",
  styleUrls: ["./cortes.component.css"],
})
export class CortesComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  catUsuarios: CatUsuarios[] = [];
  catSucursal: CatSucursales[] = [];
  cortesForm: FormGroup;
  usuario: any;

  datosAperturaTable: CatSucursales;
  public registroBitacora = new RegistroBitacoraInput();

  apertura = false;

  @Input("cortes") cortes: Cortes;
  @Output("cortesOutput") cortesOutput: EventEmitter<Cortes>;

  

  constructor(
    private formBuilder: FormBuilder,
    private cortesService: CortesService,
    private catUsuariosService: CatUsuariosService,
    private catSucursalService: CatSucursalService,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private registroBitacoraService: RegistroBitacoraService,
    private dotacionInicialService: DotacionInicialService
  ) {
    this.cortesOutput = new EventEmitter();
  }

  ngOnInit() {
    this.getAllCatUsuarios();
    this.getAllCatSucursal();
    this.cortesForm = this.formBuilder.group({
      id: [undefined],
      dotacionInicial: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      fechaApertura: [undefined],
      fechaCierre: [undefined],
      idUsuarioCajero: [undefined],
      idSucursal: [undefined],
    });
    if (this.cortes) this.cortesForm.patchValue(this.cortes);
     // Suscríbete a los cambios en dotacionInicial
     this.cortesForm.get('dotacionInicial').valueChanges.subscribe(value => {
      this.dotacionInicialService.setDotacionInicial(value);
    });
  }

  //====================================================
  //Función de muestra.
  //====================================================
  async guardarCortes() {
    try {
      if (this.cortesForm.value.dotacionInicial == null) {
        throw new Error("Por favor ingresa alguna cantidad.");
      } else if (this.cortesForm.value.dotacionInicial < 0) {
        throw new Error("No puedes ingresar una catidad menor a 0.");
      }

      await this.authenticationService.getUserByToken();
      this.usuario = this.authenticationService.currentUserValue;
      
     


      //this.cortes.idUsuarioCajero = this.usuario.id;

      if (this.cortesForm.invalid) {
        throw new Error("No paso las validaciones.");
      }
      this.cortes = this.cortesForm.value;
      var usuario = this.catUsuariosService
        .getSingle(this.usuario.id)
        .toPromise();
      if (this.cortes.id) {
        this.updateCortes(this.cortes);
      } else {
        this.cortes.id = 0;
        this.cortes.idSucursal = (await usuario).idSucursal;
        this.cortes.idUsuarioCajero = (await usuario).id;
        await this.addCortes(this.cortes);    
      }

      this.cortesOutput.emit(this.cortes);
      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
     
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarCortes");
    }
  }

  //====================================================
  //Metodos para obtener datos del servicio
  //====================================================

  async addCortes(cortes) {
    try {
      const datoretorno = await this.cortesService.add(cortes).toPromise();
      this.cortes = datoretorno;
      this.cortesForm.patchValue(this.cortes);
          
      this.registroBitacora.accion = "APERTURA DE CAJA "  ;
      const retorno = await this.registroBitacoraService.add(this.registroBitacora).toPromise();
    
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addCortes");
    }
  }

  async updateCortes(cortes: Cortes) {
    try {
      const datoRetorno = await this.cortesService.update(cortes).toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateCortes");
    }
  }

  async getCortes(id: number) {
    try {
      if (id == null) {
        const datoRetorno = await this.cortesService.getSingle(0).toPromise();
        this.cortesForm.patchValue(datoRetorno);
      } else {
        const datoRetorno = await this.cortesService.getSingle(id).toPromise();
        this.cortesForm.patchValue(datoRetorno);
        console.log("Nuevo");
     
      }
    
 
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCortes");
    }
  }

  async getAllCortes() {
    try {
      const datoRetorno = await this.cortesService.getAll().toPromise();

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllCortes");
    }
  }

  async getAllCatUsuarios() {
    try {
      const datoRetorno = await this.catUsuariosService.getAll().toPromise();
      this.catUsuarios = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatUsuarios");
    }
  }

  async getAllCatSucursal() {
    try {
      const datoRetorno = await this.catSucursalService.getAll().toPromise();
      this.catSucursal = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatSucursal");
    }
  }
}
